import MyBalance from './MyBalance';
import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import groupsSearchCollector from '../../../../../components/Hocs/GroupsSearchNewCollector';

export default ColumnsContent(groupsSearchCollector(MyBalance));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyBalance/index.js